export const ADDTOCART = "cart/addtocart";
export const MINUSQTY = "cart/minusqty";
export const PLUSQTY = "cart/plusqty";
export const DELETECART = "cart/deletecart";